// extracted by mini-css-extract-plugin
export default {"selectableCellButton":"selectableCellButton---p8hmB"};